import { render, staticRenderFns } from "./FilesFindingsModal.vue?vue&type=template&id=3dd6aae3&"
import script from "./FilesFindingsModal.vue?vue&type=script&lang=ts&"
export * from "./FilesFindingsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports